class PalpaHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.palpa-hero__slide'));
    if (!this.slides.length) return;

    this.dots = Array.from(this.querySelectorAll('.palpa-hero__dot'));
    this.index = Math.max(
      0,
      this.slides.findIndex((slide) => slide.classList.contains('is-active'))
    );
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.delay = (parseFloat(this.dataset.autoplayDelay) || 5) * 1000;
    this.shouldAutoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;

    this.classList.add('is-intro');
    this.introTimer = setTimeout(() => this.classList.remove('is-intro'), 2400);

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this.goTo(i);
        this.restart();
      });
    });

    this.onVisibilityChange = () => (document.hidden ? this.stop() : this.restart());
    document.addEventListener('visibilitychange', this.onVisibilityChange);

    this.observer = new IntersectionObserver(
      (entries) => (entries[0].isIntersecting ? this.restart() : this.stop()),
      { threshold: 0 }
    );
    this.observer.observe(this);

    this.addEventListener('shopify:block:select', (event) => {
      const selected = this.slides.indexOf(event.target);
      if (selected > -1) {
        this.goTo(selected);
        this.stop();
      }
    });
    this.addEventListener('shopify:block:deselect', () => this.restart());

    this.syncMedia();
    this.start();
  }

  disconnectedCallback() {
    this.stop();
    clearTimeout(this.introTimer);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    if (this.observer) this.observer.disconnect();
  }

  start() {
    this.stop();
    if (!this.shouldAutoplay) return;
    this.timer = setInterval(() => this.goTo(this.index + 1), this.delay);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    if (!document.hidden) this.start();
  }

  goTo(target) {
    const count = this.slides.length;
    this.index = ((target % count) + count) % count;

    this.slides.forEach((slide, i) => {
      const active = i === this.index;
      slide.classList.toggle('is-active', active);
      if (active) slide.removeAttribute('aria-hidden');
      else slide.setAttribute('aria-hidden', 'true');
    });

    this.dots.forEach((dot, i) => {
      const active = i === this.index;
      dot.classList.toggle('is-active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });

    this.syncMedia();
  }

  syncMedia() {
    this.slides.forEach((slide, i) => {
      const video = slide.querySelector('video');
      if (!video) return;

      // Safari/iOS refuse programmatic autoplay unless muted is set before the play() call.
      video.muted = true;
      if (i === this.index && !this.reduceMotion) video.play().catch(() => {});
      else video.pause();
    });
  }
}

if (!customElements.get('palpa-hero')) customElements.define('palpa-hero', PalpaHero);
